/**
 * EntityContextMenu (DESIGN.md §18.4): the context menu of ONE entity outside a list, e.g. the
 * header of a detail panel, a card or a tree node rendered on its own. Same actions, same
 * gestures as list menus (right-click, Shift+F10 / context-menu key, long-press), built from the
 * entity's action registry with `entityMenu`.
 */
import type { ReactNode } from 'react';
import { CONTEXT_ID_ATTRIBUTE, ContextMenuArea, type ContextMenuSpec } from './context-menu-area';
import { resolveActions, type ActionRegistry } from './registry';

/** Context menu spec for one or more entities of a registry (the `context` surface). */
export function entityMenu<T>(registry: ActionRegistry<T>, targets: readonly T[], title?: string): ContextMenuSpec<T> {
  return { title, actions: resolveActions(registry, targets, 'context') };
}

export interface EntityContextMenuProps {
  /** The entity's menu; undefined or no actions leaves the browser menu. */
  menu: ContextMenuSpec | undefined;
  className?: string;
  children: ReactNode;
}

const ENTITY_ID = 'entity';

export function EntityContextMenu({ menu, className, children }: EntityContextMenuProps) {
  return (
    <ContextMenuArea menuFor={menu ? () => menu : undefined}>
      <div {...{ [CONTEXT_ID_ATTRIBUTE]: ENTITY_ID }} className={className}>
        {children}
      </div>
    </ContextMenuArea>
  );
}
